import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

const UploadSlip = ({ history }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [customMessage, setCustomMessage] = useState('linhirannyc@gmail.com');
  const [totalAmount, setTotalAmount] = useState(0);
  const [slipCount, setSlipCount] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const savedAmount = localStorage.getItem('totalAmount');
    const savedCount = localStorage.getItem('slipCount');
    const lastReset = localStorage.getItem('lastReset');
    const today = new Date().toDateString();
    if (lastReset !== today) {
      localStorage.setItem('totalAmount', 0);
      localStorage.setItem('slipCount', 0);
      localStorage.setItem('lastReset', today);
    } else {
      setTotalAmount(parseFloat(savedAmount) || 0);
      setSlipCount(parseInt(savedCount) || 0);
    }
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/png')) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
      setMessage('');
      setIsSuccess(false);
    } else {
      setMessage('Please upload a valid JPEG or PNG file.');
      setFile(null);
      setPreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('Please upload a payment slip before submitting.');
      return;
    }
    try {
      const formData = new FormData();
      formData.append('paymentSlip', file);
      const response = await fetch('/verify-slip', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (response.ok) {
        setMessage('Congrats! Your Payment is valid. The process is complete!');
        setIsSuccess(true);
        setTotalAmount(totalAmount + data.details.amount.amount);
        setSlipCount(slipCount + 1);
        localStorage.setItem('totalAmount', totalAmount + data.details.amount.amount);
        localStorage.setItem('slipCount', slipCount + 1);
      } else {
        setMessage(`Error: ${data.message}`);
        setIsSuccess(false);
      }
    } catch (error) {
      setMessage('An error occurred while uploading the file.');
      setIsSuccess(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px', minHeight: '100vh', justifyContent: 'space-between' }}>
      <div style={{ maxWidth: '500px', padding: '20px', textAlign: 'center' }}>
        <img className="logo" src={logo} alt="Logo" style={{ width: '250px', marginBottom: '20px' }} />
        <h2>Upload the Bank Slips to Verify Your Payment</h2>
        <h3>(only KBANK, BBL, SCB, TTB, Krungsri, Krungthai accepted)</h3>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div>
            <label htmlFor="fileInput">Select Payment Slip (JPEG/PNG):</label>
            <input type="file" id="fileInput" accept="image/jpeg, image/png" onChange={handleFileChange} style={{ display: 'block', margin: '10px auto' }} />
          </div>
          {preview && (
            <div style={{ marginTop: '20px' }}>
              <h3>Preview:</h3>
              <img src={preview} alt="Payment Slip Preview" style={{ maxWidth: '100%', height: '250px', border: '2px solid #ddd', borderRadius: '10px', padding: '5px' }} />
            </div>
          )}
          <button
            type="submit"
            style={{
              padding: '10px 20px',
              cursor: 'pointer',
              marginTop: '20px',
              backgroundColor: '#ff0000', // Red button
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              fontSize: '16px',
              fontWeight: 'bold',
              transition: 'background 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#cc0000'} // Darker red on hover
            onMouseOut={(e) => e.target.style.backgroundColor = '#ff0000'} // Reset color
          >
            Verify Slip
          </button>
        </form>
        {message && <p style={{ marginTop: '10px', color: isSuccess ? 'green' : 'red' }}>{message}</p>}
      </div>

      <div style={{ width: '300px', padding: '20px', borderLeft: '2px solid #ccc', textAlign: 'center', backgroundColor: '#f9f9f9', borderRadius: '10px', boxShadow: '2px 2px 10px rgba(0,0,0,0.1)', marginTop: '20px' }}>
        <h3>Summary</h3>
        <p><strong>Local Time:</strong> {currentTime.toLocaleTimeString()}</p>
        <p><strong>Total Amount:</strong> ฿{totalAmount.toFixed(2)}</p>
        <p><strong>Slips Uploaded:</strong> {slipCount}</p>
      </div>

      {/* Logo 2 Positioned at Bottom */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 'auto', paddingBottom: '20px' }}>
        <p style={{ fontSize: '14px', marginBottom: '10px' }}>Powered by</p>
        <img src={logo2} alt="Logo2" style={{ width: '100px', opacity: 0.8 }} />
        <div>New Wave Consulting Group</div>
      </div>
    </div>
  );
};

export default withRouter(UploadSlip);
